import type { ReactNode } from 'react';
import { useElementWidth } from '../../hooks/useElementWidth';

// 32/68: ~250px of list in an ~780px step fits two-line rows; the editor gets the rest.
export const LIST_PANEL_WIDTH_CLASS = 'w-[32%]';
// Below this container width the panels stack: list on top (capped), details below.
export const MASTER_DETAIL_MIN_SPLIT_WIDTH_PX = 640;

interface VirtualAppointmentMasterDetailProps {
    list: ReactNode;
    detail: ReactNode;
}

// Full-height split with one divider; each panel scrolls on its own. Parent must be a flex column.
export function VirtualAppointmentMasterDetail({
    list,
    detail
}: VirtualAppointmentMasterDetailProps) {
    const { ref, width } = useElementWidth<HTMLDivElement>();
    const split = width === 0 || width >= MASTER_DETAIL_MIN_SPLIT_WIDTH_PX;
    const listClasses = split
        ? `${LIST_PANEL_WIDTH_CLASS} flex-shrink-0 border-r border-gray-200`
        : 'max-h-64 flex-shrink-0 border-b border-gray-200';

    return (
        <div ref={ref} className={`flex-1 min-h-0 flex ${split ? 'flex-row' : 'flex-col'}`}>
            <div className={`${listClasses} min-h-0 flex flex-col`}>{list}</div>
            <div className="flex-1 min-w-0 min-h-0 flex flex-col">{detail}</div>
        </div>
    );
}
